import React, {useState,setState, useEffect} from 'react';
import FormComponent from './FormComponent';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import './style.css'
import Users from './Users';
import {useLocation} from 'react-router-dom';
import MenuListComposition from './MenuList';
import Button from 'react-bootstrap/Button';
import {Link, Outlet} from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
function RegisterUser() {
 const location = useLocation();
const [visible, setVisible] = useState(false);
const handleClick  = () => {
    setVisible(!visible)
}
const [open, setOpen] = React.useState(false);
const handleClose = () => {
    setOpen(false);
  };

function show(){
    setOpen(true);
}
useEffect(()=>{
console.log("helllloooo");
},[]);

    return(
      
    <>
    <Navbar bg="dark" expand="sm">
            <Container>
                
                <Navbar.Brand href="#">Admin</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link><Link to='/'>Home</Link> </Nav.Link>
                        <Nav.Link><Link to='/survey1'>Form</Link></Nav.Link>
                        <MenuListComposition />
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>


    <h4 style={{ color: 'black', justifyContent: 'start', textAlign: 'start', paddingLeft: '4%',paddingTop: '4%' }}>Add user <span onClick={show}><PersonAddAltIcon /></span> </h4>
    
    <Users />
       

       <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
            >
        <DialogTitle id="alert-dialog-title">
          Add New User
        </DialogTitle>
        <DialogContent>
        <FormComponent/>
        </DialogContent>
        <DialogActions>
        <Button variant="secondary" onClick={handleClose}>Cancle</Button>
        </DialogActions>
      </Dialog>


           
            
            
            </>


    )       
}

export default RegisterUser